import React, { Component } from 'react'
import ContentWrapper from 'components/ContentWrapper'
import WhatWeDo from 'components/WhatWeDo'
import Process from 'components/Process'
import Layout from 'components/Layout'
import CallToAction from 'components/CallToAction'

class Approach extends Component {
  render () {
    return (
      <Layout>
        <ContentWrapper>
          <WhatWeDo title='Experience Meets Innovation' />
        </ContentWrapper>
        <ContentWrapper $background>
          <Process />
        </ContentWrapper>
        <ContentWrapper $background pb={5} />
        <ContentWrapper accent $noPadding>
          <CallToAction text={`Ready, Set, Let's Go`} />
        </ContentWrapper>
      </Layout>
    )
  }
}

// Replace 2nd arg with mapStateToProps when needing to connect to redux
export default Approach
